import React, { createContext, useContext, ReactNode } from 'react';

interface BiweeklyReportContextType {
  isBiweeklyReportView: boolean;
}

const BiweeklyReportContext = createContext<BiweeklyReportContextType>({
  isBiweeklyReportView: false,
});

export const useBiweeklyReportContext = () => useContext(BiweeklyReportContext);

interface BiweeklyReportProviderProps {
  children: ReactNode;
  isBiweeklyReportView?: boolean;
}

export const BiweeklyReportProvider: React.FC<BiweeklyReportProviderProps> = ({
  children,
  isBiweeklyReportView = false,
}) => (
  <BiweeklyReportContext.Provider value={{ isBiweeklyReportView }}>
    {children}
  </BiweeklyReportContext.Provider>
);
